import { defineStore } from "pinia";
import questionnaireApi from "@/api/questionnaire.js";

export const useQuestionnaireStore = defineStore("questionnaire", {
  state: () => ({
    address: "", //问卷地址
    token: {
      access_token: "",
      refresh_token: "",
    }, //问卷的token
  }),
  actions: {
    // 获取问卷地址
    async getAddress(cb = () => {}) {
      if (this.address) {
        cb(this.address);
        return this.address;
      }
      let res = await questionnaireApi.getQuestionnaireAddress();
      // res.data = "http://192.168.54.111:8888"; //本机调式
      cb(res.data);
      this.address = res.data;
      return res.data;
    },
    // 获取问卷token
    async getToken(cb = () => {}) {
      if (this.token.access_token) {
        cb(this.token);
        return this.token;
      }
      let res = await questionnaireApi.getToken();
      const { access_token, refresh_token } = res.data;
      const token = {
        access_token,
        refresh_token,
      };
      cb(token);
      this.token = token;
      return token;
    },
  },
});
